export const typesHkprofile = {
    
    GET_PROFILECOSMOS_SUCCESS:'GET_PROFILECOSMOS_SUCCESS',
    GET_PROFILECOSMOS_CUSTOM_SUCCESS:'GET_PROFILECOSMOS_CUSTOM_SUCCESS',
    

    GET_PROFILECOSMOS_ERROR:'GET_PROFILECOSMOS_ERROR',
    GET_PROFILECOSMOS_BEGIN:'GET_PROFILECOSMOS_BEGIN',
    GET_PROFILECOSMOS_LOGOUT:'GET_PROFILECOSMOS_LOGOUT'


}
